// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__1HcZa"};